var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,19c-2.9,0-5.7,1.1-7.8,3.2C20.2,24.3,19,27.1,19,30c0,2.9,1.1,5.7,3.2,7.8c4.3,4.3,11.3,4.3,15.5,0 c2.1-2.1,3.2-4.8,3.2-7.8c0-2.9-1.1-5.7-3.2-7.8C35.7,20.2,32.9,19,30,19 M30,43.6c-3.5,0-7-1.3-9.6-4c-2.6-2.6-4-6-4-9.6 s1.4-7.1,4-9.6c2.6-2.6,6-4,9.6-4s7.1,1.4,9.6,4c2.6,2.6,4,6,4,9.6s-1.4,7.1-4,9.6C37,42.3,33.5,43.6,30,43.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,27.8c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.6s0.2,1.1,0.6,1.6c0.8,0.8,2.3,0.8,3.1,0 c0.4-0.4,0.6-1,0.6-1.6s-0.2-1.1-0.6-1.6C31.1,28,30.6,27.8,30,27.8 M30,34.8c-1.3,0-2.5-0.5-3.4-1.4c-0.9-0.9-1.4-2.1-1.4-3.4 c0-1.3,0.5-2.5,1.4-3.4c1.8-1.8,5-1.8,6.8,0c0.9,0.9,1.4,2.1,1.4,3.4c0,1.3-0.5,2.5-1.4,3.4C32.5,34.3,31.3,34.8,30,34.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,47.1c-0.7,0-1.3-0.6-1.3-1.3v-7c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3v7 C31.3,46.6,30.7,47.1,30,47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,22.5c-0.7,0-1.3-0.6-1.3-1.3v-7c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3v7 C31.3,21.9,30.7,22.5,30,22.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,31.3h-7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h7c0.7,0,1.3,0.6,1.3,1.3 C22.5,30.7,21.9,31.3,21.2,31.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,31.3h-7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h7c0.7,0,1.3,0.6,1.3,1.3 C47.1,30.7,46.6,31.3,45.8,31.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPointer);
export default __webpack_public_path__ + "static/media/ic_pointer.bb26533b3b4b675d177cf8faf02ae564.svg";
export { ForwardRef as ReactComponent };